import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden my-12 md:my-24 mx-4 md:mx-6 rounded-[32px]">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8ab406bdb30acd5ced078c08d8f49708.jpg"
          alt="Contacta con nosotros"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-1/2 mb-8 md:mb-10 lg:mb-0">
            <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 leading-tight lowercase">
              presupuesto<br />sin compromiso
            </h2>
          </div>

          <div className="lg:w-1/2 lg:text-right space-y-6">
            <div className="text-white text-lg md:text-xl font-light leading-relaxed">
              <p>Servicio profesional en Castelldefels</p>
              <p>Disponibles 24 horas, 7 días a la semana</p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center lg:justify-end gap-4">
              <a
                href="tel:+34602365996"
                className="inline-flex items-center bg-white text-graphite rounded-full pl-4 sm:pl-6 md:pl-8 pr-2 md:pr-3 py-3 font-semibold text-sm sm:text-base md:text-lg hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="mr-2 sm:mr-3 md:mr-4">Contactar ahora</span>
                <div className="w-10 h-10 md:w-12 md:h-12 bg-graphite rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-line text-white text-lg md:text-xl"></i>
                </div>
              </a>
              <Link
                to="/contacto"
                className="inline-flex items-center border-2 border-white text-white rounded-full px-4 sm:px-6 md:px-8 py-3 font-semibold text-sm sm:text-base md:text-lg hover:bg-white hover:text-graphite transition-all cursor-pointer whitespace-nowrap"
              >
                Formulario
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
